var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollerTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000001859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0612 10.5004V5.16769C14.202 5.36011 15.2776 5.82821 16.1972 6.53115C16.3805 6.65687 16.5956 6.72507 16.8183 6.72807C17.5319 6.72807 18.1137 6.1539 18.1212 5.44036C18.1227 5.13436 18.003 4.84045 17.7879 4.62229C16.4593 3.48453 14.7928 2.81342 13.0461 2.71344V0.92575C13.0461 0.415184 12.6325 0.00160292 12.1219 0.00160292C12.1113 0.000102908 12.1007 0.000102908 12.0901 0.000102908C11.572 -0.0074909 11.1447 0.406137 11.1371 0.92575V2.65283C7.72847 2.89522 5.41058 5.00105 5.41058 7.80372C5.41058 11.2427 8.33447 12.1972 11.1371 12.9546V19.0145C9.65851 18.8161 8.26477 18.2025 7.12246 17.242C6.90735 17.0708 6.64068 16.9754 6.36496 16.9694C5.66656 17.0178 5.12876 17.6026 5.13781 18.3025C5.13631 18.6085 5.25598 18.9024 5.47109 19.1206C7.03607 20.5295 9.04796 21.3401 11.1522 21.4082V23.0747C11.1522 23.0853 11.1537 23.0959 11.1537 23.1065C11.178 23.6246 11.6188 24.0246 12.137 23.9988C12.6475 23.9988 13.0611 23.5852 13.0611 23.0747V21.3779C17.197 21.1053 18.8634 18.5904 18.8634 15.924C18.8635 12.3487 15.8639 11.2579 13.0612 10.5004ZM11.1523 10.0156C9.50101 9.5308 8.2133 9.03087 8.2133 7.62194C8.2133 6.21301 9.37984 5.19797 11.1523 5.06166V10.0156ZM13.0612 19.0448V13.5303C14.7731 14.0151 16.1063 14.6666 16.0911 16.2573C16.0911 17.4087 15.3033 18.7721 13.0612 19.0448Z",
    fill: "#A175FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollerTheme);
export default __webpack_public_path__ + "static/media/DollerTheme.5507060325b138945f55dbdcce29ca06.svg";
export { ForwardRef as ReactComponent };